import { useNavigate } from 'react-router-dom';

import Button from '../../../components/ui/Button';
import PageHeader from '../../../components/ui/PageHeader';
import DeliveryHistoryList from '../components/DeliveryHistoryList';
import DeliveryPreferencesForm from '../components/DeliveryPreferencesForm';
import { useDeliveryHistory } from '../hooks/useDeliveryHistory';
import { useMailerOrders } from '../hooks/useMailerOrders';
import { useMailPreferences } from '../hooks/useMailPreferences';

function MyDeliveryPage() {
  const navigate = useNavigate();
  const history = useDeliveryHistory();
  const prefs = useMailPreferences();
  const { data: mailerOrdersData } = useMailerOrders();

  const mailerOrders = mailerOrdersData?.data || [];

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <PageHeader
        title="My Deliveries"
        subtitle="Manage how your ballot guide is delivered to you"
      />

      {/* CTA for mailers */}
      <div className="mb-8">
        <Button onClick={() => navigate('/mailers/setup')}>Set Up Mailers for Election</Button>
      </div>

      <DeliveryPreferencesForm
        preferences={prefs.preferences}
        onSave={prefs.update}
        onDisable={prefs.disable}
        isUpdating={prefs.isUpdating}
      />
      <DeliveryHistoryList deliveries={history.data?.data} isLoading={history.isLoading} />

      {/* Mailer orders history */}
      {mailerOrders.length > 0 && (
        <div className="mt-8">
          <h2 className="text-lg font-semibold mb-4">Mailer Orders</h2>
          <div className="space-y-2">
            {mailerOrders.map((order) => (
              <div key={order.id} className="border border-neutral-200 rounded p-4">
                <p className="font-semibold">{order.election.name}</p>
                <p className="text-sm text-neutral-600">
                  {order.mailerCount} mailer(s) — ${order.totalCharged}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default MyDeliveryPage;
